import { useLocation, useParams } from 'react-router-dom';

import { itemSortOrders } from '@/enums';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getStorefrontItems } from '@/redux/modules/filteredItems';
import { changePaginationPageSize, getPaginationPageSize } from '@/redux/modules/pagination';
import { getStorefrontViewData } from '@/redux/modules/viewData';
import { parseQueryParams, validateQueryParams } from '@/utils/queryParams';

import StorefrontPage from './StorefrontPage';

type StorefrontPageParams = {
    sellerId: string;
};

const StorefrontPageContainer = () => {
    const location = useLocation();
    const params = useParams<StorefrontPageParams>();
    const dispatch = useAppDispatch();

    const queryParams = parseQueryParams(location.search);
    const { buyNow, sort } = validateQueryParams(queryParams, itemSortOrders);

    const sellerId = Number(params.sellerId || 0);
    const logoId = 'jasper52'; // for now, this is only j52 if this expands use -> getLogoID(state);
    const viewData = useAppSelector((state) => getStorefrontViewData(state, sellerId));

    const isSearch = viewData.searchTerms.length > 0;
    const sortOrder = !sort ? itemSortOrders.TIME_SOONEST_FIRST : sort;
    const pageSize = useAppSelector(getPaginationPageSize);

    const { filteredCount, items, totalCount } = useAppSelector((state) =>
        getStorefrontItems(state, {
            buyNow,
            count: pageSize,
            page: viewData.page,
            sort: sortOrder,
            terms: viewData.searchTerms,
        })
    );

    const containsBuyNowItems = true;

    return (
        <StorefrontPage
            buyNow={buyNow}
            changePaginationPageSize={(pageSize: number | 'all') => dispatch(changePaginationPageSize(pageSize))}
            containsBuyNowItems={containsBuyNowItems}
            filteredItemCount={filteredCount}
            isSearch={isSearch}
            items={items}
            logoId={logoId}
            pageSize={pageSize}
            sellerId={sellerId}
            sortOrder={sortOrder}
            totalItemCount={totalCount}
            viewData={viewData}
        />
    );
};

export default StorefrontPageContainer;
